import { render, staticRenderFns } from "./FinanceiroExtrato.vue?vue&type=template&id=77f8c6c6&scoped=true"
import script from "./FinanceiroExtrato.vue?vue&type=script&lang=js"
export * from "./FinanceiroExtrato.vue?vue&type=script&lang=js"
import style0 from "./FinanceiroExtrato.vue?vue&type=style&index=0&id=77f8c6c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77f8c6c6",
  null
  
)

export default component.exports